import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AppShell from '../components/AppShell';

/** 私隱政策（Meta App → Live 要求；亦係誠實交代會員資料點用） */
const SECTIONS = ['collect', 'use', 'share', 'retention', 'rights', 'contact'] as const;

export default function PrivacyPage() {
  const { t } = useTranslation();
  return (
    <AppShell title={t('privacy_title')}>
      <div className="p-6 max-w-2xl mx-auto text-sm leading-relaxed">
        <h1 className="text-xl font-bold mb-1">{t('privacy_title')}</h1>
        <p className="mb-5 text-xs" style={{ color: 'var(--color-text-secondary)' }}>
          {t('legal_updated')}
        </p>
        <p className="mb-5" style={{ color: 'var(--color-text-secondary)' }}>
          {t('privacy_intro')}
        </p>
        {SECTIONS.map((s) => (
          <section key={s} className="mb-5">
            <h2 className="font-semibold mb-1">{t(`privacy_${s}_h`)}</h2>
            <p style={{ color: 'var(--color-text-secondary)' }}>{t(`privacy_${s}`)}</p>
          </section>
        ))}
        <div className="mt-8 flex flex-wrap gap-4">
          <Link to="/data-deletion" style={{ color: 'var(--color-primary)' }}>
            {t('footer_deletion')}
          </Link>
          <Link to="/" style={{ color: 'var(--color-primary)' }}>
            {t('back_home')}
          </Link>
        </div>
      </div>
    </AppShell>
  );
}
